import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "../api";

const AuthCtx = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null); // null = checking, false = unauth, object = auth
  const [bootChecked, setBootChecked] = useState(false);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/auth/me");
        setUser(data);
      } catch {
        setUser(false);
      } finally {
        setBootChecked(true);
      }
    })();
  }, []);

  const requestOtp = async (phone, channel = "whatsapp") => {
    const { data } = await api.post("/auth/request-otp", { phone, channel });
    return data;
  };

  const verifyOtp = async (phone, code, extra = {}) => {
    const { data } = await api.post("/auth/verify-otp", { phone, code, ...extra });
    if (data.access_token) localStorage.setItem("aarya_token", data.access_token);
    // Persistent flag so /welcome can nudge returning users (post-logout, cache
    // clear, cookie expiry) with a subtle "your Trust Circle needs you back
    // online" banner instead of treating them as a stranger.
    try { localStorage.setItem("aarya_prev_user", "1"); } catch {}
    setUser(data.user);
    return data;
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch {}
    localStorage.removeItem("aarya_token");
    setUser(false);
  };

  const updateProfile = async (payload) => {
    const body = typeof payload === "string" ? { name: payload } : payload;
    const { data } = await api.patch("/auth/profile", body);
    setUser(data);
    return data;
  };

  return (
    <AuthCtx.Provider value={{ user, setUser, bootChecked, requestOtp, verifyOtp, logout, updateProfile }}>
      {children}
    </AuthCtx.Provider>
  );
};

export const useAuth = () => useContext(AuthCtx);
